

interface StatusBadgeProps {
  status: string
  className?: string
}

const STATUS_CONFIGS: Record<string, { color: string; label: string }> = {
  // Maintenance status
  inicial: { color: 'bg-brand-neutral-100 text-brand-neutral-700 ring-1 ring-inset ring-brand-neutral-200', label: 'Inicial' },
  pendente: { color: 'bg-brand-warning-50 text-brand-warning-700 ring-1 ring-inset ring-brand-warning-200', label: 'Pendente' },
  aprovado: { color: 'bg-brand-primary-50 text-brand-primary-700 ring-1 ring-inset ring-brand-primary-200', label: 'Aprovado' },
  executado: { color: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200', label: 'Executado' },
  rejeitado: { color: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200', label: 'Rejeitado' },
  concluido: { color: 'bg-brand-accent-50 text-brand-accent-700 ring-1 ring-inset ring-brand-accent-200', label: 'Concluído' },
  
  // Urgency status
  baixa: { color: 'bg-brand-neutral-200 text-brand-text-primary ring-1 ring-inset ring-brand-neutral-300', label: 'Baixa' },
  media: { color: 'bg-brand-warning-50 text-brand-warning-700 ring-1 ring-inset ring-brand-warning-200', label: 'Média' },
  alta: { color: 'bg-brand-accent-50 text-brand-accent-700 ring-1 ring-inset ring-brand-accent-200', label: 'Alta' },
  critica: { color: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200', label: 'Crítica' },
  
  // User status
  ativo: { color: 'bg-brand-primary-50 text-brand-primary-700 ring-1 ring-inset ring-brand-primary-200', label: 'Ativo' },
  inativo: { color: 'bg-brand-neutral-200 text-brand-text-muted ring-1 ring-inset ring-brand-neutral-300', label: 'Inativo' },
  
  // Approval levels
  automatico: { color: 'bg-brand-primary-50 text-brand-primary-700 ring-1 ring-inset ring-brand-primary-200', label: 'Automático' },
  gerente: { color: 'bg-brand-warning-50 text-brand-warning-700 ring-1 ring-inset ring-brand-warning-200', label: 'Gerente' },
  admin: { color: 'bg-brand-accent-50 text-brand-accent-700 ring-1 ring-inset ring-brand-accent-200', label: 'Administrador' },
}

export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  // Handle empty or whitespace-only status
  const normalizedStatus = status?.trim() || '';
  const config = STATUS_CONFIGS[normalizedStatus.toLowerCase()] || {
    color: 'bg-gray-100 text-gray-800',
    label: normalizedStatus || '—', // Use em dash for empty status
  }

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${className}`}
    >
      {config.label}
    </span>
  )
}